var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-form tickets"},[_c('Header',{attrs:{"withMerchant":false}}),_c('section',{staticClass:"main"},[_c('Event',{attrs:{"error":_vm.error}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }